<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-body">
        <p>
          Below are the USPS verified addresses for the entered Vendor
          information. Please verify the address changes before continuing.
        </p>
        <div class="row">
          <div class="col-6">
            <label>Current Mailing Address:</label>
            <p>{{ formattedMailingAddress }}</p>
            <label>Current Street Address:</label>
            <p>{{ formattedStreetAddress }}</p>
          </div>
          <div class="col-6">
            <label>Verified Mailing Address:</label>
            @if (normalizedMailingAddress) {
              <p>
                {{ formattedNormalizedMailingAddress }}
              </p>
            }
            <label>Verified Street Address:</label>
            @if (normalizedStreetAddress) {
              <p>
                {{ formattedNormalizedStreetAddress }}
              </p>
            }
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row w-100 justify-content-end">
          <div class="col-3">
            <button type="button" class="btn btn-danger" (click)="closeModal()">
              Cancel
            </button>
          </div>
          <div class="col-3">
            <button type="button" class="btn btn-primary" (click)="continue()">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
